
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar } from 'lucide-react';
import { RoyaltyReport } from '@/types';
import { formatDate } from '@/utils/formatters';
import StatusBadge from '@/components/common/StatusBadge';

interface ReportInformationCardProps {
  report: RoyaltyReport;
}

const ReportInformationCard: React.FC<ReportInformationCardProps> = ({ report }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Report Information</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="space-y-4">
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              <Calendar className="h-4 w-4" />
              Report Period
            </dt>
            <dd className="w-2/3 text-sm">Q{report.quarter} {report.year}</dd>
          </div>
          
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              Report Date
            </dt>
            <dd className="w-2/3 text-sm">{formatDate(report.createdAt)}</dd>
          </div>
          
          <div className="flex flex-row">
            <dt className="flex items-center gap-2 text-sm font-medium text-muted-foreground w-1/3">
              Status
            </dt>
            <dd className="w-2/3 text-sm">
              <StatusBadge status={report.status} />
            </dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  );
};

export default ReportInformationCard;
